const initState = {
  site_set: [], // 特定版位
  adtarget: null // 定向包数据
}
const state = {
  ...initState,
  initState() {
    return initState
  }
}
const mutations = {
  // 获取特定版位数据
  getSiteSetData(state, data) {
    state.site_set = data
    console.log(state.site_set, '我是site_set')
  },
  // 获取定向包数据
  getAdtarget(state, data) {
    state.adtarget = data
    console.log(state.adtarget, '我是adtarget')
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
